import type { LocationSchema } from '@libs/data-access/entities'
import type { QueryFnParams } from '@libs/data-access/queries'
import { httpServices } from '@libs/data-access/queries'

import type { FranchiseSchema } from './types/Franchise.schema'
import type { LocationUpdateSchema } from './types/Location.update.schema'

export type CheckArchivableOptions = {
  locationId: string
}

export const checkArchivable = async (opts: CheckArchivableOptions) => {
  const response = await httpServices.core.get<{
    required_to_move_contracts: boolean
  }>(`/locations/${opts.locationId}/check_archivable`)
  return response.data
}

export type FetchAllLocationsOptions = {
  queryParams?: {
    search?: string
    includes?: string[]
    all?: boolean
    archived?: boolean
  }
}

export type FetchAllLocationsResponse = LocationSchema[]

export const fetchAllLocations = async (opts?: FetchAllLocationsOptions) => {
  const response = await httpServices.core.get<FetchAllLocationsResponse>(
    `/locations`,
    { params: opts?.queryParams }
  )
  return response.data
}

export type FetchOneLocationOptions = {
  queryParams?: { includes: string[] }
  pathParams: { id: number }
}
export const fetchOneLocation = async (options: FetchOneLocationOptions) => {
  const response = await httpServices.core.get<LocationSchema>(
    `/locations/${options.pathParams.id}`,
    { params: options?.queryParams }
  )
  return response.data
}

export type CreateLocationOptions = QueryFnParams<{
  payload: {
    account_id: number
    name: string
    urssaf_name?: string
    siret?: string
    logo?: {
      filename: string
      data: string
    }
    address?: string
    zipcode?: string
    city?: string
    country?: string
    franchise_id?: number
    occupational_health_service_id?: string
    teams_attributes?: {
      name: string
    }[]
  }
}>

export type CreateLocationResponse = LocationSchema

export const createLocation = async (requestOptions: CreateLocationOptions) => {
  const response = await httpServices.core.post<CreateLocationResponse>(
    '/locations',
    requestOptions.payload
  )

  return response.data
}

export const updateOneLocation = async (
  requestOptions: LocationUpdateSchema
) => {
  const response = await httpServices.core.put<LocationSchema>(
    `/locations/${requestOptions.pathParams.id}`,
    requestOptions.payload
  )

  return response.data
}

export type DeleteOneLocationOptions = {
  pathParams: { id: number }
}
export const deleteOneLocation = async (
  requestOptions: DeleteOneLocationOptions
) => {
  const response = await httpServices.core.delete<{}>(
    `/locations/${requestOptions.pathParams.id}`
  )

  return response.data
}

export type FetchFranchisesOptions = QueryFnParams<{
  queryParams: {
    search?: string
  }
}>

export const fetchFranchises = async (opts: FetchFranchisesOptions) => {
  const response = await httpServices.core.get<FranchiseSchema[]>(
    `/franchises`,
    {
      params: opts.queryParams
    }
  )
  return response.data
}
